module.exports = __webpack_public_path__ + "fb173f99162a08ad724ffe8811849c1f.png";